export interface Testimonial {
  id: number;
  name: string;
  role: string;
  avatar: string;
  text: string;
  rating: number;
  stationName?: string;
  category: 'oyente' | 'locutor' | 'dueno';
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Mariana Solís',
    role: 'Oyente desde 2024',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%2C%20warm%20genuine%20smile%2C%20natural%20lighting%2C%20casual%20modern%20style%2C%20clean%20bright%20background%2C%20friendly%20approachable%20look&width=160&height=160&seq=testimonial-mariana&orientation=squarish',
    text: 'Descubrí Radio Frecuencia hace dos años y cambió mi forma de escuchar radio. Ahora sigo a mis locutores favoritos, les mando saludos en vivo y hasta participo en los concursos. Es como tener la radio en el bolsillo pero con esteroides.',
    rating: 5,
    category: 'oyente',
  },
  {
    id: 2,
    name: 'Carlos Mendoza',
    role: 'Director de Tardes de Pop FM',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latino%20radio%20host%2C%20confident%20friendly%20expression%2C%20professional%20casual%20style%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20media%20personality&width=160&height=160&seq=testimonial-carlos&orientation=squarish',
    text: 'Como locutor, tener una plataforma donde puedo publicar contenido, fotos de la cabina y conectar con mis oyentes fuera del aire es algo que ninguna otra herramienta me daba. Mis oyentes aman la sección de Comunidad.',
    rating: 5,
    stationName: 'Tardes de Pop FM',
    category: 'locutor',
  },
  {
    id: 3,
    name: 'Ana Patricia Vega',
    role: 'Dueña de Radio Esperanza FM',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20mature%20Latina%20businesswoman%2C%20elegant%20casual%20style%2C%20confident%20warm%20smile%2C%20soft%20studio%20lighting%2C%20professional%20yet%20approachable%2C%20clean%20background&width=160&height=160&seq=testimonial-ana&orientation=squarish',
    text: 'Registrar mi radio en Radio Frecuencia fue lo mejor que hice este año. Pasamos de 200 oyentes diarios en nuestra web a más de 2,000 en la plataforma. Las herramientas de galería de fotos y videos nos ayudan a mostrar lo que hacemos en cabina.',
    rating: 5,
    stationName: 'Radio Esperanza FM',
    category: 'dueno',
  },
  {
    id: 4,
    name: 'Diego Ramírez',
    role: 'Oyente fiel',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latino%20man%2C%20casual%20friendly%20smile%2C%20everyday%20style%2C%20warm%20natural%20daylight%2C%20clean%20background%2C%20relatable%20approachable%20expression&width=160&height=160&seq=testimonial-diego&orientation=squarish',
    text: 'Lo que más me gusta es poder escuchar la radio de mi pueblo aunque esté en la capital. Sigo conectado con mi comunidad y las noticias locales. La app es súper fácil de usar y no se traba nunca.',
    rating: 5,
    category: 'oyente',
  },
  {
    id: 5,
    name: 'Natalia Campos',
    role: 'Locutora de Mañanas con Energía',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Latina%20radio%20host%2C%20dynamic%20energetic%20expression%2C%20modern%20professional%20style%2C%20bright%20studio%20lighting%2C%20clean%20background%2C%20charismatic%20media%20personality&width=160&height=160&seq=testimonial-natalia&orientation=squarish',
    text: 'Los mensajes de voz de los oyentes que llegan por la plataforma son ORO PURO. Los ponemos al aire y la gente enloquece. Además las fotos de eventos que subimos han sido clave para atraer patrocinadores nuevos.',
    rating: 5,
    stationName: 'Mañanas con Energía',
    category: 'locutor',
  },
  {
    id: 6,
    name: 'Francisco Gutiérrez',
    role: 'Fundador de Radio Costa Rica Online',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle%20aged%20Latino%20entrepreneur%2C%20confident%20business%20casual%20style%2C%20genuine%20friendly%20smile%2C%20professional%20studio%20lighting%2C%20clean%20background%2C%20successful%20approachable&width=160&height=160&seq=testimonial-francisco&orientation=squarish',
    text: 'Probé 4 plataformas antes de Radio Frecuencia. Lo que me convenció fueron las transmisiones en vivo integradas y la posibilidad de tener mi propia landing page de eventos. El soporte responde en minutos, no en días.',
    rating: 5,
    stationName: 'Radio Costa Rica Online',
    category: 'dueno',
  },
  {
    id: 7,
    name: 'Sofía Martínez',
    role: 'Oyente Premium',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Latina%20woman%20with%20headphones%2C%20music%20lover%20style%2C%20bright%20cheerful%20smile%2C%20soft%20natural%20light%2C%20creative%20casual%20look%2C%20clean%20background&width=160&height=160&seq=testimonial-sofia&orientation=squarish',
    text: 'Soy de esas personas que escucha radio TODO el día. Radio Frecuencia me permite cambiar de estación sin perder lo que estaba escuchando. Las listas de reproducción comunitarias son mi debilidad.',
    rating: 4,
    category: 'oyente',
  },
  {
    id: 8,
    name: 'Javier Montero',
    role: 'Productor de Contenido Digital',
    avatar:
      'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20creative%20professional%2C%20modern%20artistic%20style%2C%20confident%20intelligent%20expression%2C%20soft%20studio%20lighting%2C%20clean%20contemporary%20background&width=160&height=160&seq=testimonial-javier&orientation=squarish',
    text: 'Trabajo con tres radios diferentes y poder administrarlas desde un solo panel es un sueño. Las estadísticas en tiempo real me ayudan a tomar decisiones de programación al instante. Brutal la herramienta.',
    rating: 5,
    category: 'dueno',
  },
];